import { RequestService, type RequestOptions } from '../request-service';
import type {
  ListOffersRequest,
  ListOffersResponse,
} from '@wix/ambassador-dealer-v1-serving-offer/types';
import type RpcModule from '@wix/ambassador-dealer-v1-serving-offer/rpc';
import type HttpModule from '@wix/ambassador-dealer-v1-serving-offer/http';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class DealerServingOfferService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-dealer-v1-serving-offer/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-dealer-v1-serving-offer/http');
  }

  async listOffers(
    payload: ListOffersRequest,
    options?: RequestOptions,
  ): Promise<ListOffersResponse> {
    return this.request<ListOffersRequest, ListOffersResponse>({
      methodName: 'listOffers',
      payload,
      options,
    });
  }
}
